export const savedToolsIdentifier = "SmartWidgetSavedTools";